import React, { FunctionComponent, ReactNode } from 'react';
import { Typography } from '@altibox/design-system-component-lib';

import { Image, ImageProps } from 'src/components/image';

import { StyledButton, StyledInnerContainer, StyledImageContainer } from './choose-button.styled';

interface Props {
  items: SelectButtonItem[];
  title: ReactNode;
  onClick: () => void;
}

export interface SelectButtonItem {
  icon: ImageProps;
  text: string;
  isValueSensitive?: boolean;
}

export const ChooseButton: FunctionComponent<Props> = (props) => {
  const { items, title, onClick } = props;

  return (
    <StyledButton onClick={onClick}>
      {title}
      {items.map((item, index) => (
        <StyledInnerContainer key={index}>
          <StyledImageContainer>
            <Image {...item.icon} />
          </StyledImageContainer>
          <Typography variant="paragraph3" component="p" data-hj-suppress={item.isValueSensitive}>
            {item.text}
          </Typography>
        </StyledInnerContainer>
      ))}
    </StyledButton>
  );
};
